<template>
  <div class="my-3">
    <label for="estado-revision">Estado Revision:</label>
    <v-select 
      id="estadoRevi" 
      v-model="estadoRevis" 
      :options="estadosrev" 
      placeholder="Estado Rev."
      :reduce="option => option.value" 
      label="text" 
      class="d-inline-block w-100" />
    <b-table 
      v-if="itemsadi.length > 0" 
      bordered striped responsive 
      :items="itemsadi" 
      :fields="fieldsadi"
    >
    </b-table> 
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import rutas from "@/assets/utils/rutas.json";
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BCard,
  BLink,
  BTable,
  BFormSelect,
  BFormFile,
  BFormTextarea,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";

export default {

  name: "AuditarAtencion",
  
 props: {
   idAtencion:{
     type: String,
     default: ''
   },
   itemAtencion: {
     type: Object,
     default: () => ([]) // Provides a default empty object if not passed
   },
  },
 components: {
   FormWizard,
   TabContent,
   BFormCheckbox,
   BFormTextarea,
   BFormCheckboxGroup,
   BRow,
   BLink,
   BButton,
   BCard,
   BTable,
   flatPickr,
   BCol,
   BFormGroup,
   BFormDatepicker,
   BFormInput,
   BFormSelect,
   BFormFile,
   vSelect,
   // eslint-disable-next-line vue/no-unused-components
   ToastificationContent,
 },
 data() {
   return {
     diagnosticoSeleccionado: null,
     aislamientoSeleccionado: null,
     diagnosticos: ['Definitivo', 'Presuntivo'],
     aislamiento: ['Ninguno', 'Parcial', 'Medio', 'Total'],
     visible: false,
     estadosrev: [
       { value: '0', text: 'Atendida' },// Acaba de ser atentida por el doctor
       { value: '1', text: 'Por revisar' },// El auditor ya dio sus comentarios
       { value: '2', text: 'Revisada' }, // El doctor ya corrigio las observaciones del auditor
       { value: '3', text: 'Concluida' }, // El auditor da por terminada la atencion
       { value: '4', text: 'Anulada' },  // El doctor anula la atencion.
       { value: '5', text: 'Auditada' }  // El doctor anula la atencion.
     ],
     collapseItemID: "",
     estadoRevis: null,
     titularsel: "",
     openOnHover: this.$parent.hover,
     options: {},
     titulares: [],
     antecedentes: [],
     signosVitalesExisten: false, // Variable para verificar si existen Signos Vitales
     // Otras propiedades para los Signos Vitales
     itemSignosVital: null,
     opsMenu: [
       { value: "0", text: "INFORMACIÓN SOBRE LA REACCIÓN ADVERSA" },
       { value: "1", text: "INFORMACIÓN DEL MEDICAMENTO " },
       { value: "2", text: "DESENLACE " },
     ],
     fieldsti: [
       { key: "nombre", label: "Descripcion", thClass: "text-center" },
       {
         key: "acciones",
         label: "acciones",
         sortable: true,
         thClass: "text-center",
         tdClass: "text-right",
       },
     ]
   };
 },
 created() {
   
   
   const idSignosVital = this.$route.params.id;
   //this.fetchViewUpdateSignosVital(idSignosVital);
 },
 computed:{
   itemsadi() {
 const savedComments = localStorage.getItem('comments');
 if (savedComments) {
   this.commentsAte = JSON.parse(savedComments);
 }
 let items = [];
 const comate = this.commentsAte[this.idAtencion];

 console.log("Esto contiene comate", comate);

 for (let key in comate) {
   if (Array.isArray(comate[key]) && comate[key].length > 0) {
     
     let comatekey = comate[key]
     console.log("esto contiene key", key)

     console.log("esto contiene comatekey", comatekey)
     if (comatekey.length > 0 && comatekey[0]  && !('checked' in comatekey[0])) {
       for (let item in comatekey) {
         let comatekeyin = comatekey[item]
         console.log("esto contiene comatekeyin", comatekeyin)

       for (let subKey in comatekeyin) {
         console.log("esto contiene subkey", subKey)
         //AQUI NO ES UN ARRAY EN LOS CASOS DE MOTIVO CONSULTA ETC
       if (Array.isArray(comatekeyin[subKey])) {
         comatekeyin[subKey].forEach(sub => {
           if (sub && sub.checked) {
             items.push({
               section: this.sectionToLabel(key),
               descripcion: sub.value,
               comment: sub.text,
               status: sub.status || 'atendida' // Asegúrate de obtener el estado correcto
             });
             console.log("imprime items", items)
           }
         });
       
     }
       
     }
     }
     
   } else if(comatekey.length > 0 && ('checked' in comatekey[0])) {
       for (let item in comatekey) {
         console.log("esto contiente item", comatekey[item])
         let element = comatekey[item]
         console.log(element)
         if(element && element.checked === true) {
           console.log("entra aqui adadada")
           items.push({
               section: this.sectionToLabel(key),
               descripcion: element.value,
               comment: element.text,
               status: element.status || 'atendida' // Asegúrate de obtener el estado correcto
             });
         }
       }
   }
      
   else if (comate[key] && typeof comate[key] === 'object') {
     for (let subKey in comate[key]) {
       if (Array.isArray(comate[key][subKey])) {
         comate[key][subKey].forEach(item => {
           if (item && item.checked === 'true' || item.checked === true) {
             items.push({
               section: this.sectionToLabel(key),
               descripcion: item.value,
               comment: item.text,
               status: item.status || 'atendida' // Asegúrate de obtener el estado correcto
             });
             console.log("imprime items 2", items)
           }
         });
       }
     }
   }
 }
}

 return items;
}
,
   fieldsadi() {
     return [
       { key: 'section', label: 'Sección' },
       { key: 'descripcion', label: 'Descripcion' },
       { key: 'comment', label: 'Comentario' },
       { key: 'status', label: 'Estado' },
     ];
   },
 },
 methods: {
   
   

   increment() {
     const input = document.getElementById("number");
     input.stepUp(1);
   },
   sectionToLabel(section) {
     const labels = {
       "motivoc": "Motivo Consulta",
       "problemaactual": "Problema Actual",
       "tipoc": "Tipo Consulta",
       "ptratamiento": "Plan Tratamiento",
       "apersonal": "Ant. Personal",
       "afamiliar": "Ant. Familiar",
       "rorganos": "Rev. Organos",
       "diagn": "Diagnosticos",
       "recet": "Recetas",
       "imagenes": "Imagenes",
       "laboratorio": "Laboratorio",
       "terapias": "Terapias",
       "cirugias": "Cirugias",
       "proceso": "Procesos"
     };
     return labels[section] || section; // Fallback to the key if no label is defined
   },
   decrement() {
     const input = document.getElementById("number");
     input.stepDown(1);
   },
   agregarTitular() {
     switch (this.titularsel) {
       case "0":
         // Agregar Motivo De Consulta
         this.titulares.push({
           type: "Motivo De Consulta",
           content: this.motivoConsulta,
         });
         this.motivoConsulta = ""; // Limpia el cuadro de texto
         break;
       case "1":
         // Agregar Antecedentes Patológicos Personas
         this.titulares.push({
           type: "Antecedentes Patológicos Personas",
           content: this.antecedentes.join(", "),
         });
         this.antecedentes = []; // Limpia los checkboxes seleccionados
         break;
       case "2":
         // Agregar Antecedentes Patológicos Personas
         this.titulares.push({
           type: "Antecedentes Patológicos Familiares",
           content: this.antecedentes.join(", "),
         });
         this.antecedentes = []; // Limpia los checkboxes seleccionados
         break;
       // Agrega más casos según necesites
     }
     // Elimina la opción seleccionada de opsMenu
     this.opsMenu = this.opsMenu.filter(
       (option) => option.value !== this.titularsel
     );
     this.titularsel = ""; // Limpia la selección
   },
   removeItem(itemToRemove) {
     const index = this.titulares.findIndex(
       (item) =>
         item.type === itemToRemove.type &&
         item.content === itemToRemove.content
     );
     if (index !== -1) {
       // Antes de eliminar el titular, verifica qué opción corresponde y agrégala de nuevo a opsMenu
       switch (itemToRemove.type) {
         case "Motivo De Consulta":
           this.opsMenu.push({ value: "0", text: "Motivo De Consulta" });
           break;
         case "Antecedentes Patológicos Personas":
           this.opsMenu.push({
             value: "1",
             text: "Antecedentes Patológicos Personas",
           });
           break;
         case "Antecedentes Patológicos Familiares":
           this.opsMenu.push({
             value: "1",
             text: "Antecedentes Patológicos Personas",
           });
           break;
         // Añade más casos según necesites
       }
       this.titulares.splice(index, 1);
     }
   },
   async auditarAtencion(idAtencion) {
   if (this.estadoRevis) {
     if (this.estadoRevis !== '0') {
       const savedComments = localStorage.getItem('comments');
       if (savedComments) {
         this.commentsAte = JSON.parse(savedComments);
       }

       const comate = this.commentsAte[idAtencion];
       if (comate) {
         // Filter out null values and only include checked items
         const filteredComate = {  };
         

         // for (let section in comate) {
         //   filteredComate[section] = []
         // }

           for (let section in comate) {
           if (Array.isArray(comate[section])) { //evalua si es un array 
             let comatesection = comate[section]
             
             for (let i in comate[section] ) {
               
               let comatein = comatesection[i]
               for (let j in comatein) {
                 let comatefin = comatein[j]
                                  
                   if (comatefin[0] && comatefin[0].checked) {
                     if(!Array.isArray(filteredComate[section])) {
                       filteredComate[section] = []
                     }
                     
                     filteredComate[section].push(comatefin[0])
                   }
                 
               }

             
             }
             for (let h in comatesection) {
                 
                 let cometa = comatesection[h]
                                
                   if (cometa && cometa.checked) {
                     if(!Array.isArray(filteredComate[section])) {
                       filteredComate[section] = []
                     }
                     filteredComate[section].push(cometa)
                   }
                 
               }


           }
         }
         console.log("esto contiene filteredComate", filteredComate)

         const atenMedArg = {
           idAte: idAtencion,
           comate: JSON.stringify(filteredComate),
           estadoRev: this.estadoRevis
         };

         try {
           const response = await axios.post(rutas.axios + 'api', {
             query: `
               mutation auditarAtencion($idAte: String!, $comate: String!, $estadoRev: String!){
                 auditarAtencion(
                   idAte: $idAte
                   comate: $comate
                   estadoRev: $estadoRev
                 ){
                   comtatem {
                     id
                     token
                   }
                   status
                   message
                 }
               }
             `,
             variables: atenMedArg
           });

           if (response.status === 200) {
             this.$swal({
               title: 'Modificado',
               text: 'Estado de atenciones actualizados',
               icon: 'success',
               confirmButtonColor: '#3085d6'
             }).then((result) => {
               if (result.isConfirmed) {
                 //this.$router.go(0);
               }
             });
           } else {
             this.$swal({
               title: 'Error',
               text: response.status,
               icon: 'error',
               confirmButtonColor: '#089599',
             });
           }
         } catch (error) {
           console.error("Error in auditarAtencion:", error);
           this.$swal({
             title: 'Error',
             text: 'Error en la solicitud',
             icon: 'error',
             confirmButtonColor: '#089599',
           });
         }
       } else {
         this.$swal({
           title: 'Error',
           text: 'No hay comentarios para auditar',
           icon: 'error',
           confirmButtonColor: '#089599',
         });
       }
     } else {
       this.$swal({
         title: 'Error',
         text: "No puede escoger estado de revision Atendida",
         icon: 'error',
         confirmButtonColor: '#089599',
       });
     }
   } else {
     this.$swal({
       title: 'Error',
       text: "Tiene que escoger un estado de revision",
       icon: 'error',
       confirmButtonColor: '#089599',
     });
   }
 },
 
 },
};
</script>
